import React from "react"
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer"

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid black",
    paddingBottom: 10,
  },
  logo: {
    width: 200,
    marginBottom: 10,
  },
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-80%, -50%)",
    width: "50%",
    opacity: 0.1,
  },
  table: {
    display: "table",
    width: "auto",
    marginTop: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "12%",
    backgroundColor: "#f2f2f2",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
  },
  tableCol: {
    width: "12%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ddd",
  },
  tableCellHeader: {
    margin: 3,
    fontWeight: "bold",
    fontSize: 8,
    textAlign: "center",
  },
  tableCell: {
    margin: 3,
    fontSize: 8,
    textAlign: "center",
  },
  section: {
    marginBottom: 10,
  },
  sectionInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid black",
    paddingBottom: 10,
    marginBottom: 10,
  },
  sectionTotales: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 10,
    marginBottom: 10,
  },
  title: {
    textAlign: "center",
    marginVertical: 10,
    fontSize: 14,
    fontWeight: "bold",
    color: "#1976d2",
  },
  subtitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#333",
  },
  totalContainer: {
    marginLeft: "auto",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 20,
  },
  column: {
    flexDirection: "column",
    marginLeft: 10,
    alignItems: "flex-end",
  },
  label: {
    fontWeight: "bold",
    padding: "2px 0",
  },
  value: {
    textAlign: "right",
    padding: "2px 0",
    minWidth: 100,
  },
  horizontalLine: {
    borderBottom: "1px solid black",
    marginVertical: 5,
    width: "100%",
  },
  horizontalLineVoid: {
    borderBottom: "1px solid white",
    marginVertical: 5,
    width: "100%",
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 30,
    paddingTop: 20,
    borderTop: "1px solid #ccc",
  },
  signatureBlock: {
    flex: 1,
    textAlign: "center",
  },
  signatureLine: {
    borderTop: "1px solid #000",
    width: 150,
    margin: "10px auto",
  },
  signatureName: {
    marginTop: 2,
    fontSize: 10,
  },
  infoBlock: {
    flex: 1,
    paddingHorizontal: 10,
  },
  infoLabel: {
    fontWeight: "bold",
    fontSize: 9,
  },
  infoValue: {
    fontSize: 9,
    marginBottom: 3,
  },
  statusBadge: {
    backgroundColor: "#4caf50",
    color: "white",
    padding: "2px 8px",
    borderRadius: 3,
    fontSize: 9,
    fontWeight: "bold",
  },
})

const PedidoWebPDF = ({ data }) => {
  // Función para formatear fecha
  const formatDate = (dateString) => {
    if (!dateString) return "N/A"
    try {
      const date = new Date(dateString)
      return date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    } catch {
      return dateString
    }
  }

  // Función para obtener texto del estado
  const getStatusText = (status) => {
    switch (status) {
      case "A":
        return "ACTIVO"
      default:
        return status
    }
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Sello de agua */}
        {data.cabecera.ciaselloagua && (
          <Image style={styles.watermark} src={`data:image/jpeg;base64,${data.cabecera.ciaselloagua}`} />
        )}

        {/* Encabezado con logo y datos empresa */}
        <View style={styles.header}>
          {data.cabecera.cialogo && (
            <Image style={styles.logo} src={`data:image/jpeg;base64,${data.cabecera.cialogo}`} />
          )}
          <View>
            <Text>{data.cabecera.empresaNombre || "EMPRESA"}</Text>
            <Text>Teléfonos: {data.cabecera.ciatelefonosPDF || "N/A"}</Text>
            <Text>RUC: {data.cabecera.ciaruc || "N/A"}</Text>
            <Text>{data.cabecera.lugarPDF || ""}</Text>
            {/* <Text>{data.cabecera.ciaescontespPDF || ""}</Text> */}
          </View>
        </View>

        {/* Título principal */}
        <Text style={styles.title}>PEDIDO WEB: {data.cabecera.pednumped || "N/A"}</Text>

        {/* Información del pedido */}
        <View style={styles.sectionInfo}>
          <View style={styles.infoBlock}>
            <Text style={styles.subtitle}>INFORMACIÓN DEL PEDIDO</Text>
            <Text style={styles.infoLabel}>Nickname:</Text>
            <Text style={styles.infoValue}>{data.cabecera.nickname || "N/A"}</Text>

            <Text style={styles.infoLabel}>Fecha Emisión:</Text>
            <Text style={styles.infoValue}>{formatDate(data.cabecera.pedfecemi)}</Text>

            <Text style={styles.infoLabel}>Fecha Vencimiento:</Text>
            <Text style={styles.infoValue}>{formatDate(data.cabecera.pedfecven)}</Text>

            {/* <Text style={styles.infoLabel}>Estado:</Text>
            <View style={{ flexDirection: "row" }}>
              <Text style={styles.infoValue}>{getStatusText(data.cabecera.pedstatus)}</Text>
            </View> */}
          </View>

          <View style={styles.infoBlock}>
            <Text style={styles.subtitle}>DATOS ADICIONALES</Text>
            <Text style={styles.infoLabel}>Vendedor:</Text>
            <Text style={styles.infoValue}>{data.cabecera.vennombre || "N/A"}</Text>

            <Text style={styles.infoLabel}>Localidad:</Text>
            <Text style={styles.infoValue}>{data.cabecera.locdescri || "N/A"}</Text>

            <Text style={styles.infoLabel}>Comentario:</Text>
            <Text style={styles.infoValue}>{data.cabecera.comentario || "Sin comentarios"}</Text>

            {/* <Text style={styles.infoLabel}>IVA Aplicado:</Text>
            <Text style={styles.infoValue}>{data.cabecera.pedporiva || 0}%</Text> */}
          </View>
        </View>

        {/* Tabla de productos */}
        <Text style={{ ...styles.subtitle, textAlign: "center", marginTop: 15 }}>DETALLE DE PRODUCTOS</Text>

        <View style={styles.table}>
          {/* Encabezados de tabla */}
          <View style={styles.tableRow}>
            <View style={{ ...styles.tableColHeader, width: "5%" }}>
              <Text style={styles.tableCellHeader}>#</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "12%" }}>
              <Text style={styles.tableCellHeader}>Código</Text>
            </View>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCellHeader}>Imagen</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "25%" }}>
              <Text style={styles.tableCellHeader}>Descripción</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "10%" }}>
              <Text style={styles.tableCellHeader}>Cantidad</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "12%" }}>
              <Text style={styles.tableCellHeader}>Precio Unit.</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "12%" }}>
              <Text style={styles.tableCellHeader}>Descuento</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "12%" }}>
              <Text style={styles.tableCellHeader}>IVA {data.cabecera.pedporiva || 0}%</Text>
            </View>
            <View style={{ ...styles.tableColHeader, width: "12%" }}>
              <Text style={styles.tableCellHeader}>Total</Text>
            </View>
          </View>

          {/* Filas de productos */}
          {data.detalle.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <View style={{ ...styles.tableCol, width: "5%" }}>
                <Text style={styles.tableCell}>{item.pedsecuen || index + 1}</Text>
              </View>
              <View style={{ ...styles.tableCol, width: "12%" }}>
                <Text style={styles.tableCell}>{item.artcodigo || "N/A"}</Text>
              </View>
              <View style={styles.tableCol}>
                <Image style={styles.tableImageCell} src={`data:image/jpeg;base64,${item.artimagen}`} />
              </View>
              <View style={{ ...styles.tableCol, width: "25%" }}>
                <Text style={styles.tableCell}>{item.artdescri || "Sin descripción"}</Text>
              </View>
              <View style={{ ...styles.tableCol, width: "10%" }}>
                <Text style={styles.tableCell}>{parseFloat(item.pedcantidad || 0).toFixed(2)}</Text>
              </View>
              <View style={{ ...styles.tableCol, width: "12%" }}>
                <Text style={styles.tableCell}>${parseFloat(item.pedpreven || 0).toFixed(2)}</Text>
              </View>
              <View style={{ ...styles.tableCol, width: "12%" }}>
                <Text style={styles.tableCell}>${parseFloat(item.pedvaldesc || 0).toFixed(2)}</Text>
              </View>
              <View style={{ ...styles.tableCol, width: "12%" }}>
                <Text style={styles.tableCell}>${parseFloat(item.pedvaliva || 0).toFixed(2)}</Text>
              </View>
              <View style={{ ...styles.tableCol, width: "12%" }}>
                <Text style={styles.tableCell}>
                  <Text style={{ fontWeight: "bold" }}>${parseFloat(item.pedvaltot || 0).toFixed(2)}</Text>
                </Text>
              </View>
            </View>
          ))}
        </View>

        {/* Totales */}
        <View style={styles.totalContainer}>
          <View style={styles.column}>
            <Text style={styles.horizontalLineVoid}></Text>
            <Text style={styles.label}>Base con IVA:</Text>
            <Text style={styles.label}>Base sin IVA:</Text>
            <Text style={styles.horizontalLineVoid}></Text>
            <Text style={styles.label}>Subtotal Bruto:</Text>
            <Text style={styles.label}>Descuento Directo:</Text>
            <Text style={styles.horizontalLine}></Text>
            <Text style={styles.label}>Subtotal Neto:</Text>
            <Text style={styles.label}>IVA Total:</Text>
            <Text style={styles.horizontalLine}></Text>
            <Text style={{ ...styles.label, fontSize: 12, color: "#1976d2" }}>TOTAL PEDIDO:</Text>
          </View>
          <View style={styles.column}>
            <Text style={styles.horizontalLineVoid}></Text>
            <Text style={styles.value}>${parseFloat(data.cabecera.pedtivapor || 0).toFixed(2)}</Text>
            <Text style={styles.value}>${parseFloat(data.cabecera.pedtivacer || 0).toFixed(2)}</Text>
            <Text style={styles.horizontalLineVoid}></Text>
            <Text style={styles.value}>${parseFloat(data.cabecera.pedsubtot || 0).toFixed(2)}</Text>
            <Text style={styles.value}>${parseFloat(data.cabecera.peddesdirecto || 0).toFixed(2)}</Text>
            <Text style={styles.horizontalLine}></Text>
            <Text style={styles.value}>
              ${(parseFloat(data.cabecera.pedsubtot || 0) - parseFloat(data.cabecera.peddesdirecto || 0)).toFixed(2)}
            </Text>
            <Text style={styles.value}>${parseFloat(data.cabecera.pediva || 0).toFixed(2)}</Text>
            <Text style={styles.horizontalLine}></Text>
            <Text style={{ ...styles.value, fontSize: 12, fontWeight: "bold", color: "#1976d2" }}>
              ${parseFloat(data.cabecera.pedtotal || 0).toFixed(2)}
            </Text>
          </View>
        </View>

        {/* Nota adicional */}
        {data.cabecera.notapedido1 && (
          <View
            style={{
              ...styles.section,
              borderTop: "1px dashed #ccc",
              paddingTop: 10,
              marginTop: 20,
            }}
          >
            <Text style={{ fontStyle: "italic", fontSize: 9 }}>NOTA: {data.cabecera.notapedido1}</Text>
          </View>
        )}

        {/* Firmas */}
        <View style={styles.signatureSection}>
          <View style={styles.signatureBlock}>
            <View style={styles.signatureLine} />
            <Text style={styles.signatureName}>Cliente</Text>
          </View>
          <View style={styles.signatureBlock}>
            <View style={styles.signatureLine} />
            <Text style={styles.signatureName}>Autorización Empresa</Text>
          </View>
        </View>

        {/* Pie de página */}
        <View
          style={{
            position: "absolute",
            bottom: 30,
            left: 30,
            right: 30,
            fontSize: 8,
            color: "#666",
            textAlign: "center",
            borderTop: "1px solid #eee",
            paddingTop: 10,
          }}
        >
          <Text>
            Documento generado automáticamente - {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
          </Text>
          <Text>
            Pedido Web {data.cabecera.pednumped || ""} - {data.cabecera.empresaNombre || ""}
          </Text>
        </View>
      </Page>
    </Document>
  )
}

export default PedidoWebPDF
